import './lib/sentry';
import './lib/axiosSetup';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';

import App from './app';
import './config/i18n';
import { loadLang } from './config/langResources';
import { getPreLoginLang } from './lib/preLoginLang';
import { resolveCurrentLangCode } from './config/currentLang';

// 예외로 null 이면 로그인 전 선택을 쓴다.
const detectBootLang = () => resolveCurrentLangCode() || getPreLoginLang();

const renderApp = () => ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

loadLang(detectBootLang()).then(renderApp).catch(renderApp);